import React, { createContext, useContext } from "react";

export const AuthenticationContext = createContext(null);

export const AuthenticationProvider = ({ children }) => {
  const [verification, setVerification] = React.useState();

  return (
    <AuthenticationContext.Provider value={{ verification, setVerification }}>
      {children}
    </AuthenticationContext.Provider>
  );
};

export const useAuthentication = () => {
  return useContext(AuthenticationContext);
};
